import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vfs-context-menu-item',
  templateUrl: './context-menu-item.component.html',
  styleUrls: ['./context-menu-item.component.scss']
})
export class ContextMenuItemComponent {

 @Input() name: string;

}
